import { render, staticRenderFns } from "./RegistrationsStartCard.vue?vue&type=template&id=7b4a7815&"
import script from "./RegistrationsStartCard.vue?vue&type=script&lang=ts&"
export * from "./RegistrationsStartCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports